import React from "react";
import {LineChart,AreaChart,Area, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer} from "recharts";
import {useListVals} from "react-firebase-hooks/database";
import Firebase from "../../Firebase";
import {useCollection} from "react-firebase-hooks/firestore";


const db = Firebase.firestore();
function ProductsSold(props){

    var moment = require('moment');

    var colors = ["#d70206",
        "#0d47a1",
        "#388e3c",
        "#d17905",
        "#C2185B"]

    const [sales] = useCollection(
        db.collection('sales'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [weekdays, setWeekDays] = React.useState([]);
    const [labelArray, setLabelArray] = React.useState([]);
    const [dataArray, setDataArray] = React.useState([]);
    const [loading , setLoading] = React.useState(false);


    var todayNum = moment().isoWeekday();
    //var lastWeekToday = todayNum - 14;
    //console.log(moment().weekday(lastWeekToday));

    React.useEffect(() => {

        //setLoading(true);
        var periodNumber;
        if(props.period === "Last 7 days" ){
            periodNumber = 7;
        }else if(props.period === "Last 30 days"){
            periodNumber = 30;
        } else {
            periodNumber = 90;
        }

        var weekArray = [];
        var labelArray = [];

        for(var i=0; i<periodNumber; i++){
            weekArray.push({"date" : moment().weekday(todayNum - i).format("YYYY-MM-DD"),
                "name" : moment().weekday(todayNum - i).format("dddd")});
            labelArray.push(moment().weekday(todayNum - i).format("DD/MM"));
        }

        setLabelArray(labelArray);
        setWeekDays(weekArray);

        var tempArray = []
        if(sales){
            var salesArray = []
            sales.docs.map((item) => {
                salesArray.push(item.data());
            })
            weekArray.map((weekday) => {
                var count = 0;

                var filtered = salesArray.filter(x => (moment(x.updatedAt, "YYYY-MM-DD h:mm:SSS").format("YYYY-MM-DD") === weekday.date));
                //console.log(filtered);
                count = filtered.length;

                tempArray.push({
                    name : moment(weekday.date, "YYYY-MM-DD").format("DD/MM"),
                    count: count
                });
            });
            setDataArray([...tempArray.reverse()]);
        }

    }, [moment, props.period, sales, todayNum])


    return (

        <ResponsiveContainer width="100%" height={250} className="d-flex justify-content-center text-center">
            <LineChart
                data={dataArray}
                margin={{
                    top: 5,
                    right: 10,
                    left: 0,
                    bottom: 2,
                }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false}/>
                <Tooltip />
                <Legend />
                <Line type="monotone" strokeWidth={1} dataKey="count" stroke={colors[Math.floor(Math.random()*colors.length)]} fillOpacity={0.6} fill="url(#colorUv)" />
            </LineChart>
        </ResponsiveContainer>


    )
}

export default ProductsSold;
